module.exports = __webpack_public_path__ + "img/bornutti24.472786ba.jpg";